export const SearchListingDivider = ({ theme }) => {
  return (
    <div
      className={`line-search max-lg:h-[1px] max-lg:w-[calc(100%_-_32px)] max-lg:ml-4 h-full flex-0 bg-slate-200 ${theme === 'vertical' ? 'mx-auto w-[calc(100%_-_32px)] !h-[1px]' : 'lg:py-[22px] w-[1px]'}`}
    />
  );
};
